import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditTest() {
    const {test_id} = useParams();
    const [cat, setCat] = useState([]);
    const [rows, setRows] = useState([]);
    const [cats, setCats] = useState([]);
    const [subcats, setsubCats] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [testData, settestData] = useState({
        "cat": '',
        "subcat": '',
        "test": '',
        "sample": '',
        "method": '',
        "ranges": '',
        "units": '',
        "ordering": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-test/' + test_id)
                .then(function (response) {
                    settestData({
                        cat_id: response.data.cat.id,
                        subcat_id: response.data.subcat.id,
                        test: response.data.test,
                        sample: response.data.sample,
                        method: response.data.method,
                        ranges: response.data.ranges,
                        units: response.data.units,
                        ordering: response.data.ordering,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        settestData({
            ...testData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('cat', testData.cat_id);
        _formData.append('subcat', testData.subcat_id);
        _formData.append('test', testData.test);
        _formData.append('sample', testData.sample);
        _formData.append('method', testData.method);
        _formData.append('ranges', testData.ranges);
        _formData.append('units', testData.units);
        _formData.append('ordering', testData.ordering);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-test/' + test_id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/view-test/');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'cat/')
                .then(function (response) {
                    setCats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + 'subcat/')
                .then(function (response) {
                    setsubCats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleDelete = (test_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-test/' + test_id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <div className="row">

                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Tests</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="cat_id" className="form-label">Category</label>
                                    <select name="cat_id" value={testData.cat_id} onChange={handleChange}
                                            className="form-control">
                                        {cats.map((category, index) => {
                                            return <option key={index} value={category.id}>{category.category}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="subcat_id" className="form-label">Sub Category</label>
                                    <select name="subcat_id" value={testData.subcat_id} onChange={handleChange}
                                            className="form-control">
                                        {subcats.map((subcategory, index) => {
                                            return <option key={index} value={subcategory.id}>
                                                {subcategory.subcat}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="test" className="form-label">Add Component</label>
                                    <sup style={{fontSize: '0.8em', color: 'red', verticalAlign: 'super'}}>
                                        dont use single or double quotes or comma
                                    </sup>
                                    <input type="text" className="form-control" name="test" value={testData.test}
                                           onChange={handleChange} id="test"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="sample" className="form-label">Sample Type</label>
                                    <input type="text" className="form-control" name="sample" value={testData.sample}
                                           onChange={handleChange} id="sample"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="method" className="form-label">Method</label>
                                    <input type="text" className="form-control" name="method" value={testData.method}
                                           onChange={handleChange} id="method"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="ranges" className="form-label">Ranges</label>
                                    <sup style={{fontSize: '0.8em', color: 'red', verticalAlign: 'super'}}>
                                        dont use single or double quotes or comma
                                    </sup>
                                    <textarea className="form-control" name="ranges" id="ranges" value={testData.ranges}
                                              onChange={handleChange} required></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="units" className="form-label">Units</label>
                                    <input type="text" className="form-control" name="units" value={testData.units}
                                           onChange={handleChange} id="units"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="ordering" className="form-label">Ordering No</label>
                                    <input type="text" className="form-control" name="ordering"
                                           value={testData.ordering}
                                           onChange={handleChange} id="ordering"/>
                                </div>
                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditTest;